export const getMerchant = (merchantId, merchants) => {
    return merchants.get('merchants').find(m => m.id === merchantId)
}

export const getMerchantCountry = (merchant) => {
    return merchant.billingAddress ? merchant.billingAddress.country : ''
}
